<template>
  <section id="dashboard-ecommerce">
    <b-overlay :show="onProgress">
      <b-row class="match-height">
        <b-col cols="12">
          <statistics :data="data.statistics"/>
        </b-col>
      </b-row>
      <b-row class="match-height">
        <b-col md="6" v-if="!onProgress && data.openTasks.length">
          <users :table-data="data.openTasks" title="کاربران دارای بیشترین وظایف باز"/>
        </b-col>
        <b-col md="6" v-if="!onProgress && data.sentTasks.length">
          <users :table-data="data.sentTasks" title="کاربران داری بیشترین وظایف ارسالی"/>
        </b-col>
        <b-col md="6" v-if="!onProgress && data.inboxTasks.length">
          <users :table-data="data.inboxTasks" title="کاربران داری بیشترین وظایف دریافتی"/>
        </b-col>
        <b-col md="6" v-if="!onProgress && data.completedTasks.length">
          <users :table-data="data.completedTasks" title="کاربران داری بیشترین وظایف تکمیل شده"/>
        </b-col>
        <b-col md="6" v-if="!onProgress && data.mostCommentTasks.length">
          <tasks :table-data="data.mostCommentTasks" title="وظایف با بیشترین نظر"/>
        </b-col>
      </b-row>
    </b-overlay>

  </section>
</template>

<script>
import { BRow, BCol, BOverlay } from 'bootstrap-vue'
import { doubleRaf } from '@/libs/utils'
import Statistics from './statistics.vue'
import users from './usersTable.vue'
import tasks from './taskTable.vue'

export default {
  components: {
    BRow,
    BCol,
    Statistics,
    users,
    tasks,
    BOverlay,
  },
  data() {
    return {
      data: {},
      onProgress: false,
    }
  },
  created() {
    // data
    this.onProgress = true

    this.$http.get('/reports/tasks')
        .then(response => {
          this.data = response.data
          doubleRaf(() => {
            this.onProgress = false
          })
        })
  },
}
</script>
